import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Loader from "../../../components/Loader";
import EditableTable from "./UserDonationTable";
import Modal from "../../../components/Modal";
import ChangeLog from "../../../components/ChangeLog";
import { alertSuccess, alertError } from "../../../components/Alert";

import {
  fetchUserDonationList,
  updateUserDonation,
  setPageSize,
} from "@/slices/RedeemSlice/userDonationSlice";

import SimplePagination from "@/components/SimplePagination";
import PageSizeSelector from "@/components/PageSizeSelector";
import PanelUserSearch from "@/components/PanelUserSearch";

import api from "../../../auth/api"; // ✅ keep for agency

export default function UserDonation() {
  const dispatch = useDispatch();

  const {
    list,
    currentPage,
    totalPages,
    status,
    search,
    pageSize, cache ,
  } = useSelector((state) => state.userDonationList);

  const [editRowId, setEditRowId] = useState(null);
  const [editedData, setEditedData] = useState({});
  const [searchInput, setSearchInput] = useState(search || "");

  const [agencyList, setAgencyList] = useState([]); // ✅ same
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentLog, setCurrentLog] = useState([]);
  
   const [selectedRows, setSelectedRows] = useState([]); // ✅ Track selected rows

  const editableFields = ["donatDetail"];

  // ✅ SAME (AS IT IS)
  const getAgencyList = async () => {
    try {
      const response = await api.get("/redeem/panel/agency");
      setAgencyList(response.data.result);
    } catch (error) {
      console.error(error);
    }
  };

  
  // ✅ INITIAL LOAD
  useEffect(() => {
      // dispatch(fetchUserDonationList({ fetchAll: true, search: encodeURIComponent(searchInput) }));

    dispatch(fetchUserDonationList({ page: 1, search: encodeURIComponent(searchInput) }));
    getAgencyList();
  }, [dispatch]);

  // ✅ SEARCH
  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(fetchUserDonationList({ page: 1, search: encodeURIComponent(searchInput) }));
    }, 800);

    return () => clearTimeout(timer);
  }, [searchInput]);

  // ✅ PAGE CHANGE
  useEffect(() => {
    dispatch(fetchUserDonationList({ page: currentPage,  search: encodeURIComponent(searchInput) }));
  }, [currentPage]);

  const headers =
    list?.length > 0
      ? Object.keys(list[0]).filter((key) => key !== "id")
      : [];

  const handleEdit = (id) => {
    setEditRowId(id);
    const row = list.find((r) => r.id === id);
    setEditedData(row);
  };

const handleSave = async () => {
  const payload = { donation: selectedRows.map((id) => ({ id })) };

  const res = await dispatch(updateUserDonation(payload));
  
  if (!res.error) {
     let succMess = res.payload.success;
      alertSuccess(succMess);
    setEditRowId(null);
   
    // ✅ CLEAR selection (IMPORTANT)
    setSelectedRows([]);

     // ✅ Fetch fresh paginated data (normal page)
    dispatch(fetchUserDonationList({
      page: currentPage,
      search: encodeURIComponent(searchInput)
    }));

    // ✅ Also fetch full data for “Select All” in background (cache only)
    // dispatch(fetchUserDonationList({
    //   fetchAll: true,
    //   search: encodeURIComponent(searchInput)
    // }));

  }
  
};

  // ✅ Submit selected rows
  // const handleSubmit = async () => {
  //   if (selectedRows.length === 0) return;
  //   try {
  //     const payload = { donation: selectedRows.map((id) => ({ id })) };
  //     await api.patch("/redeem/panel/donation", payload);
  //     alert("Selected donations updated!");
  //     setSelectedRows([]);
  //     dispatch(fetchUserDonationList({ page: currentPage, search }));
  //   } catch (err) {
  //     console.error(err);
  //     alert("Update failed");
  //   }
  // };


  const handleChange = (e, field) => {
    setEditedData((prev) => ({
      ...prev,
      [field]: e.target.value,
    }));
  };

  const handleLog = (id) => {
    const row = list.find((r) => r.id === id);
    setCurrentLog(row?.oldTrack || []);
    setIsModalOpen(true);
  };

  if (status === "loading") return <Loader />;

  const hasData = list?.length > 0;
  const isSearching = searchInput && searchInput.trim() !== "";



  return (
  <div className="flex flex-col items-center p-1">

    {/* 🔍 SEARCH */}
    <PanelUserSearch value={searchInput} onChange={setSearchInput} />

    <div className="w-full flex items-center flex-col">

      <div className="max-w-[95%] w-full">

        {hasData ? (
          <EditableTable
            headers={headers}
            rows={list}
            editRowId={editRowId}
            editedData={editedData}
            handleEdit={handleEdit}
            //  fullData={fullData}  
            // handleSave={handleSave}
            handleCancel={() => setEditRowId(null)}
            handleChange={handleChange}
            editableFields={editableFields}
            handleLog={handleLog}
            agencyList={agencyList}
            showAction={false}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows} // ✅ pass state to table
          />
        ) : (
          <div className="w-full flex flex-col items-center justify-center py-20 text-gray-500">

            {/* Icon */}
            <div className="text-5xl mb-3">🔍</div>

            {/* Message */}
            {searchInput ? (
              <>
                <p className="text-lg font-medium">No results found</p>
                <p className="text-sm mt-1">
                  for "<span className="font-semibold">{searchInput}</span>"
                </p>
              </>
            ) : (
              <>
                <p className="text-lg font-medium">No Data Available</p>
                <p className="text-sm mt-1">
                  There are no donations to display
                </p>
              </>
            )}
          </div>
        )}
      </div>

      {/* ✅ PAGINATION */}
       {!(isSearching && !hasData) && (
      <div className="flex mt-4 items-center justify-between w-11/12">

        {/* hide when search */}
       
          <PageSizeSelector
            pageSize={pageSize}
            setPageSize={(size) => {
              dispatch(setPageSize(size));
              dispatch(fetchUserDonationList({ page: 1, search: encodeURIComponent(searchInput) }));
            }}
          />
    
          <SimplePagination
            currentPage={currentPage}
            setCurrentPage={(page) =>
              dispatch(fetchUserDonationList({ page, search: encodeURIComponent(searchInput) }))
            }
            totalPages={totalPages}
          />
      </div>
       )}

        {/* ✅ SUBMIT BUTTON */}
        {selectedRows.length > 0 && (
          <div className="mt-3 flex justify-end w-11/12">
            <button
              onClick={handleSave}
              className="bg-blue-500 text-white px-2 py-1 rounded-md hover:bg-blue-600 text-md"
            >
              Submit
            </button>
          </div>
        )}
    </div>

    <Modal
      isOpen={isModalOpen}
      onClose={() => setIsModalOpen(false)}
      title="Change Log"
      content={<ChangeLog data={currentLog} />}
    />
  </div>
);
}